<ng-container *ngIf="memberCard$ | async as memberCard; else loadingRef">
  <ng-container *ngIf="memberDetails$ | async as memberDetails; else loadingRef">
    <div class="member-card bg-primary text-white p-3 d-flex flex-column">
      <ng-container *ifScreenSize="screenSize.Desktop">
        <div class="card-header d-flex flex-row justify-content-between align-items-center">
          <div class="card-header-item">
            <div class="card-name fw-light-bold font-page-heading">{{ memberDetails.FirstName }} {{ memberDetails.Surname }}</div>
            <label class="card-account-no font-size-14"
              >{{ 'member.card.account.number' | translate }} - {{ memberCard.ExternalRefNumber }}</label
            >
          </div>

          <img class="card-header-img" src="/assets/images/jets-logo.png" alt="jets logo" />
        </div>
        <div class="flex-row d-flex justify-content-between align-items-center w-100">
          <div class="item-card-container">
            <span class="icons material-icons" aria-hidden="true">loyalty</span>
            <div class="d-flex flex-column justify-content-center gap-1">
              <label class="balance-text fw-light-bold font-page-heading">{{ pointsBalance$ | async | number }}</label>
              <label class="subheading-text font-size-12">{{ 'member.card.points.label' | translate }}</label>
            </div>
          </div>
          <div class="item-card-container">
            <span class="icons material-symbols-outlined" aria-hidden="true">money_bag</span>

            <div class="d-flex flex-column justify-content-center gap-1">
              <label class="balance-text fw-light-bold font-page-heading">{{ ecash$ | async | FortressCurrencyPipe }}</label>
              <label class="subheading-text font-size-12">{{ 'member.card.ecash.label' | translate }}</label>
            </div>
          </div>
        </div>

        <div class="add-card">
          <fgb-add-card-payment />
        </div>
      </ng-container>
      <!--Mobile card-->
      <div class="d-block d-lg-none">
        <div class="card-name fw-light-bold font-page-heading">{{ memberDetails.FirstName }} {{ memberDetails.Surname }}</div>

        <label class="card-account-no mb-1"
          >{{ 'member.card.account.number' | translate }} {{ memberCard.ExternalRefNumber }}</label
        >

        <hr />
        <div class="d-flex justify-content-between align-items-center">
          <div class="points">
            <label class="subheading-text text-capitalize">{{ 'member.card.points.label' | translate }}</label>
            <div class="balance-text">{{ pointsBalance$ | async | number }}</div>
          </div>

          <div class="ecash">
            <label class="subheading-text text-capitalize">{{ 'member.card.ecash.label' | translate }}</label>
            <div class="balance-text">{{ ecash$ | async | FortressCurrencyPipe }}</div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</ng-container>
<ng-template #loadingRef>
  <fgb-loading></fgb-loading>
</ng-template>
